<template>
    <div>
        <section :class="['section', 'business-summary', { 'is-review-summary': isReviewDetailsPage }]">
            <p v-if="fetchingBusiness" class="has-text-centered spinner"><img src="/static/img/spinner.svg" alt="Getting business detail" /></p>
            <div v-if="!fetchingBusiness" class="level is-mobile">
                <!-- ITEM PROP BUSINESS DETAILS ONLY -->
                <div v-if="isReviewDetailsPage" class="level-left">
                    <div class="level-item">
                        <img :class="['business-logo', { 'is-review-detail': isReviewDetailsPage }]" :src="businessLogo" :alt="`${business} logo`" />                    </div>
                    <div class="level-item">
                        <p v-if="!isReviewDetailsPage" class="summary">
                            <strong class="business-name" v-html="$options.filters.breakSent(record.businessName)"></strong><br/>
                            <span class="industry"><router-link :to="`/industries/${record.industrySlug}`" v-html="record.industryName"></router-link></span><br/>
                            <rating :stars="reviewAverage" :business-detail="smallStars"></rating>
                            <span class="review-summary is-hidden-mobile" v-html="reviewSummaryHtml"></span>
                            <span hidden>{{ averageRating | precise(2) }}</span><span class="review-count is-hidden-tablet" v-html="reviewCount"></span>
                            <span :class="['summary-trust-index', { 'zero-trust-index' : record && record.trustIndex === 0 }, 'has-text-weight-bold', 'is-hidden-tablet']" v-html="summaryTrustIndex"></span>
                            <span v-if="!isResponding && !fetchingBusiness" class="has-text-right is-this-your-business is-hidden-tablet"><br/><a :href="portalFeaturesUrl" target="_blank">Is this your business?</a></span>
                        </p>
                        <p v-if="isReviewDetailsPage" class="summary">
                            <span class="business-name review-details">A review of <a :href="`/${business}`"><span class="has-text-weight-bold" v-html="record.businessName"></span></a></span><br/>
                            <span class="review-author-details is-hidden-mobile" v-html="reviewDetailSnippet"></span>
                        </p>
                    </div>
                </div>



                <!-- ITEM PROP HERE ONLY -->
                <div v-if="!isReviewDetailsPage" class="level-left" itemscope itemtype="http://schema.org/LocalBusiness">
                    <h1 hidden itemprop="name" v-html="record.businessName"></h1>
                    <div hidden itemprop="image" itemscope itemtype="http://schema.org/ImageObject">
                        <span itemprop="url" v-html="businessLogo"></span>
                    </div>
                    <div hidden itemprop="aggregateRating" itemscope itemtype="http://schema.org/AggregateRating">
                        <span hidden itemprop="ratingValue" v-html="averageRating"></span>
                        <span hidden itemprop="reviewCount" v-html="totalReviews"></span>
                    </div>

                    <div class="level-item">
                        <img :class="['business-logo', { 'is-review-detail': isReviewDetailsPage }]" :src="businessLogo" :alt="`${business} logo`" />
                    </div>
                    <div class="level-item mobile-level">
                        <p v-if="!isReviewDetailsPage" class="summary">
                            <strong class="business-name" v-html="$options.filters.breakSent(record.businessName)"></strong><br/>
                            <span class="industry"><router-link :to="`/industries/${record.industrySlug}`" v-html="record.industryName"></router-link></span><br/>
                            <rating :stars="reviewAverageReal" :isAvg="true" :business-detail="smallStars" class="avg-rating"></rating>
                            <span class="review-summary is-hidden-mobile" v-html="reviewSummaryHtml"></span>
                            <span class="review-count is-hidden-tablet" v-html="reviewCount"></span>
                            <span :class="['summary-trust-index', { 'zero-trust-index' : record && record.trustIndex === 0 }, 'has-text-weight-bold', 'is-hidden-tablet']" v-html="summaryTrustIndex"></span>
                            <span v-if="isPaidSubscription && !isReviewDetailsPage" class="review-summary is-hidden-desktop is-hidden-tablet verify-text-mobile">
                                <img class="fa-check-circle-mobile" alt="This business responds" src="/static/img/business/verified-business.png" srcset="/static/img/business/verified-business@2x.png 2x, /static/img/business/verified-business@3x.png 3x" />
                              verified business
                            </span>
                            <span v-if="isPaidSubscription && !isReviewDetailsPage" class="review-summary is-hidden-mobile verify-text">
                                <img class="fa-check-circle" alt="This business responds" src="/static/img/business/verified-business.png" srcset="/static/img/business/verified-business@2x.png 2x, /static/img/business/verified-business@3x.png 3x" />
                                <span>this is a verified business</span>
                            </span>
                            <span v-if="!isResponding && !fetchingBusiness" class="has-text-right is-this-your-business is-hidden-tablet"><br/><a :href="portalFeaturesUrl" target="_blank">Is this your business?</a></span>
                        </p>
                        <p v-if="isReviewDetailsPage" class="summary">
                            <span class="business-name review-details">A review of <a :href="`/${business}`"><span class="has-text-weight-bold" v-html="record.businessName"></span></a></span><br/>
                            <span class="review-author-details is-hidden-mobile" v-html="reviewDetailSnippet"></span>
                        </p>
                    </div>
                </div>


                <div v-if="!isReviewDetailsPage" class="level-right is-hidden-mobile is-hidden-tablet-only">
                    <div v-if="record.trustIndex > 0" class="level-item container-box">
                        <p><span class="has-text-weight-bold">TRUST</span>INDEX RATING</p>
                        <p v-text="record.trustIndex"></p>
                        <p>OUT OF 10</p>
                    </div>
                    <div v-if="record.trustIndex === 0" class="level-item container-box">
                        <p><span class="has-text-weight-bold">TRUST</span>INDEX RATING</p>
                        <p class="no-nps-data line-heigth-23">Not enough reviews to calculate</p>
                    </div>
                    <div v-if="totalReviews >= 10" class="level-item container-box">
                        <p>RANKING</p>
                        <p v-text="industryRankingHtml"></p>
                        <p v-html="industryNameHtml"></p>
                    </div>
                    <div v-if="totalReviews < 10" class="level-item container-box">
                        <p>INDUSTRY RANKING</p>
                        <p class="no-nps-data line-heigth-23">Not enough reviews to calculate</p>
                    </div>
                    <div class="level-item container-box net-promoter">
                        <p>NET PROMOTER SCORE</p>
                        <div v-if="hasNpsData" class="nps-total" v-text="getNpsTotal"></div>
                        <span class="bottom-left nps-component-icon" @click="showTooltip = !showTooltip">
                            <i class="is-fixed-bottom fas fa-info-circle"></i>
                        </span>
                        <p class="no-nps-data nps-data" v-if="!hasNpsData">No NPS data to display</p>

                        <v-popover
                          v-if="showTooltip"
                            trigger="manual"
                            :open="showTooltip"
                            placement="bottom-start"
                        >
                            <template slot="popover">
                                <p>This score indicates how likely it is for reviewers to recommend this business. Less than 0 = unlikely, 1 to 49 = likely and above 49 = very likely. For more information on how the NPS is collected and calculated,
                                    <a target="_blank" href="https://blog.hellopeter.com/faqs/your-net-promoter-score">read more here</a>.</p>
                            </template>
                        </v-popover>

                    </div>
                </div>
                <div v-if="!isReviewDetailsPage" class="level-right is-hidden-mobile is-hidden-desktop">
                    <div v-if="record.trustIndex === 0" class="level-item container-box">
                        <p><span class="has-text-weight-bold">TRUST</span>INDEX RATING</p>
                        <p class="no-nps-data line-heigth-23">Not enough reviews to calculate</p>
                    </div>
                    <div v-if="record.trustIndex > 0" class="level-item container-box">
                        <p><span class="has-text-weight-bold">TRUST</span>INDEX RATING</p>
                        <p v-text="record.trustIndex"></p>
                        <p>OUT OF 10</p>
                    </div>
                    <div v-if="totalReviews >= 10" class="level-item container-box">
                        <p>RANKING</p>
                        <p v-text="industryRankingHtml"></p>
                        <p v-html="industryNameHtml"></p>
                    </div>
                    <div v-if="totalReviews < 10" class="level-item container-box">
                        <p>INDUSTRY RANKING</p>
                        <p class="no-nps-data line-heigth-23">Not enough reviews to calculate</p>
                    </div>
                    <div class="level-item container-box">
                        <p>NET PROMOTER SCORE</p>
                        <div v-if="hasNpsData" class="nps-total" v-text="getNpsTotal"></div>
                        <p class="no-nps-data" v-if="!hasNpsData">No NPS data to display</p>
                    </div>
                </div>
            </div>
            <p v-if="!isResponding && !fetchingBusiness && !isReviewDetailsPage" class="has-text-right is-this-your-business is-hidden-mobile"><a :href="portalFeaturesUrl" target="_blank">Is this your business?</a></p>
        </section>
        <section class="section business-columns">
            <div class="review-details-list columns is-paddingless is-marginless">

              <!-- FOR MOBILE -->
              <div v-if="isMobileAds" :class="['column', 'is-marginless', 'is-hidden-tablet', { 'is-paddingless' : isReviewDetailsPage }]">
                <div :class="['container', 'left-pane', { 'is-review-details': isReviewDetailsPage }]">
                  <div v-if="isMobileAds" class="error-message is-hidden-desktop flash-mobile">
                    <flash-message :addBottomMargin="true"></flash-message>
                  </div>
                  <router-view></router-view>
                </div>
              </div>

              <!-- FOR DESKTOP -->
              <div v-if="!isMobileAds" class="column review-details-list-inner is-marginless is-two-thirds-desktop is-hidden-mobile">
                  <div :class="['container', 'left-pane', { 'is-review-details': isReviewDetailsPage }]">
                    <div class="error-message flash-desktop">
                      <flash-message :addBottomMargin="true"></flash-message>
                    </div>
                    <router-view></router-view>
                  </div>
              </div>
              <div class="column right-column is-hidden-tablet-only is-hidden-mobile">
                  <div class="container">
                      <ad v-if="!isMobileAds" :ad-object="desktopAds[0]"></ad>
<!--                        <leader-board-medium></leader-board-medium>-->
                      <div v-if="showRatingsChart">
                          <star-rating-widget
                                  :top-margin-small="smallTopMargin"
                                  :short-summary="starDescriptionText"
                                  :smaller-font-size="starDescriptionText"
                                  :white-back-ground="starDescriptionText"
                                  :box-shadow="starDescriptionText"
                                  :final-score="averageRating"
                                  :total-reviews="totalReviews"
                                  :one="oneStar"
                                  :two="twoStar"
                                  :three="threeStar"
                                  :four="fourStar"
                                  :five="fiveStar"
                                  :star-description-text="starDescriptionText"
                                  :hide-logo="starDescriptionText"
                                  :hide-summary="starDescriptionText"></star-rating-widget>
                      </div>
                      <h4 class="has-text-weight-bold">Month on month industry ranking</h4>
                      <div class="columns is-marginless is-mobile">
                          <div v-for="monthRecord in monthRecords" class="industry-rank-card column">
                              <span>#{{ monthRecord.industryRanking }}</span><br/><span v-text="monthRecord.month"></span>
                          </div>
                      </div>
                      <h4 class="has-text-weight-bold">Month on month TrustIndex</h4>
                      <vue-chart chart-type="ComboChart" :columns="trustIndexOverTimeColumns" :rows="trustIndexOverTimeRows" :options="trustIndexOverTimeOptions"></vue-chart>

                      <!--Add section for avarage response time--->
                      <div  v-if="averageResponseTime >0">
                        <article class="media grey-back ">
                          <div class="media-left">
                            <figure class="image is-44x45">
                              <img src="/static/img/reviews/response-time.svg" alt="Time to reply" />
                            </figure>
                          </div>
                          <div class="media-content">
                            <p class="is-size-6 is-size-7-mobile is-height-45 is-size-ipad">Average time to reply</p>
                          </div>
                          <div class="time_content">
                            <div class="media-right">
                              <p class="is-size-3 is-size-4-mobile is-height-45 is-size-ipad has-text-weight-bold" v-text="averageResponseTime"></p>
                            </div>
                            <div class="level-item">
                              <p class="is-size-6 is-size-7-mobile is-height-45 is-size-ipad has-text-weight-bold" v-html="printAverageResponseTime"></p>
                            </div>
                          </div>
                        </article>
                      </div>
                      <!--End section for avarage response time--->

                      <ad v-if="!isMobileAds" :ad-object="desktopAds[1]"></ad>
<!--                        <leader-board-medium></leader-board-medium>-->
                      <h4 v-if="hasBusinessDescription || hasWebsite" class="has-text-weight-bold" v-html="aboutText"></h4>
                      <p v-if="hasBusinessDescription" class="business-description" v-text="record.businessDetails.description"></p> <!-- hasPaidSubscription &&  -->
                      <a v-if="hasWebsite" class="button is-outlined is-fullwidth" rel="nofollow" target="_blank" :href="websiteFullPath">VISIT OUR WEBSITE</a>
                      <h4 v-if="hasSocialLinks || hasBusinessAddress || hasBusinessEmail || hasBusinessPhone" class="has-text-weight-bold" v-html="connectWithText"></h4>
                      <div v-if="hasPaidSubscription && hasSocialLinks" class="columns is-mobile">
                          <div v-for="socialLink in socialLinks" class="column">
                              <a :href="socialLink.url" target="_blank" rel="nofollow" :class="socialLink.style"><i :class="socialLink.icon"></i></a>
                          </div>
                          <div v-for="socialLinkOffset in socialLinksOffset" class="column">&nbsp;</div>
                      </div>
                      <p v-if="hasBusinessAddress" class="mini-title">Where we live:</p>
                      <p v-if="hasBusinessAddress" class="has-text-left mini-detail" v-html="record.businessDetails.address"></p>
                      <p v-if="hasPaidSubscription && hasBusinessEmail" class="mini-title">Write to us:</p>
                      <p v-if="hasPaidSubscription && hasBusinessEmail" class="has-text-left mini-detail" v-html="record.businessDetails.email"></p>
                      <p v-if="hasPaidSubscription && hasBusinessPhone" class="mini-title">Call us on:</p>
                      <p v-if="hasPaidSubscription && hasBusinessPhone" class="has-text-left mini-detail" v-html="record.businessDetails.tel"></p>
                      <ad v-if="(hasSocialLinks || hasBusinessAddress || hasBusinessEmail || hasBusinessPhone) && !isMobileAds" :ad-object="desktopAds[2]"></ad>
<!--                        <leader-board-medium v-if="hasSocialLinks || hasBusinessAddress || hasBusinessEmail || hasBusinessPhone"></leader-board-medium>-->
                      <h4 v-if="hasKeywords" class="has-text-weight-bold">Popular keywords:</h4>
                      <p v-if="hasKeywords" class="has-text-left mini-detail">
                          <span v-for="keyword in keywords" class="tag is-white" v-html="keyword"></span>
                      </p>
<!--                        <leader-board-medium v-if="hasKeywords"></leader-board-medium>-->
                  </div>
              </div>

            </div>
        </section>
    </div>
</template>
<script>
    import axios from 'axios'
    import Rating from '@/components/Rating'
    import StarRatingWidget from '@/components/StarRatingWidget'
    import qs from 'qs'
    import moment from 'moment'
    import LeaderBoardMedium from '@/components/LeaderBoardMedium'
    import FlashMessage from '@/components/FlashMessage'
    import Ad from '@/components/ProgrammaticAds'

    export default {
        name: 'BusinessDetail',
        components: {
            Rating,
            LeaderBoardMedium,
            StarRatingWidget,
            FlashMessage,
            Ad
        },
        props: {
            business: {
                type: String
            }
        },
        created () {
            this.isMobileAds = window.innerWidth <= 767
            window.events.$on('review-detail-loaded', (data) => {
                this.reviewDetailAuthor = data.author
                this.reviewDetailDate = data.reviewDate
            })
            window.events.$on('review-detail-desktop-ads', (data) => {
              this.desktopAds = data
            })
            window.events.$on('business-detail-desktop-ads', (data) => {
              this.desktopAds = data
            })
            this.getBusinessDetail()
            this.getBusinessStats()
            this.getMonthOnMonthGraph()
        },
        computed: {
          /**
           * check whether current subscription has paid subscription or not
           *
           * @returns {boolean}
           */
            isPaidSubscription () {
                if (typeof this.record !== 'undefined') {
                    return this.record.businessDetails.isPaid
                }
                return false
            },
            loaded () {
                return this.fetchingBusiness === false &&
                    this.fetchingStats === false &&
                    typeof this.record !== 'undefined' &&
                    typeof this.stats !== 'undefined'
            },
            reviewAverage () {
                if (typeof this.stats !== 'undefined') {
                    return Math.floor(parseFloat(this.stats.reviewAverage))
                }
                return 0
            },
            reviewAverageReal () {
              if (typeof this.stats !== 'undefined' && typeof this.stats.reviewAverage !== 'undefined' && this.stats.reviewAverage !== null) {
                return parseFloat(this.stats.reviewAverage).toFixed(2)
              }

              return 0
            },
            reviewSummaryHtml () {
                if (typeof this.stats !== 'undefined') {
                    const total = parseInt(this.stats.totalReviews)
                  return `Average rating of <span class="has-text-weight-bold">${this.reviewAverageReal}</span> from <span class="has-text-weight-bold">${total} reviews</span>`
                }
                return ''
            },
            isResponding () {
                if (typeof this.record !== 'undefined') {
                    return this.record.businessDetails.isActiveSubscription
                }
                return false
            },
            industryRankingHtml () {
                if (typeof this.record != 'undefined') {
                    return `#${this.record.industryRanking}`
                }
                return 'N/A'
            },
            industryNameHtml () {
                if (typeof this.record !== 'undefined') {
                    const slug = this.record.industrySlug
                    const name = this.record.industryShortName ?  this.record.industryShortName.toUpperCase() : this.record.industryName.toUpperCase()
                    return `IN <a href="/industries/${slug}">${name}</a>`
                }
                return ''
            },
            summaryTrustIndex () {
                if (typeof this.record !== 'undefined') {
                    if (this.record.trustIndex === 0) {
                        return `<br/>Not enough reviews to calculate TrustIndex<br/>`
                    }
                    return `TrustIndex: ${this.record.trustIndex}/10`
                }
                return ''
            },
            reviewCount () {
                if (typeof this.stats !== 'undefined') {
                    if (this.stats.totalReviews < 100) {
                        return `${this.stats.totalReviews}&nbsp;reviews&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`
                    }
                    return `${this.stats.totalReviews}&nbsp;reviews`
                }
                return ''
            },
            businessLogo () {
                if (typeof this.record !== 'undefined') {
                    if (this.record.businessDetails.logo !== null && this.record.businessDetails.logo !== '') {
                        return this.record.businessDetails.logo
                    }
                    return this.record.industryLogo
                }
                const domain = process.env.APP_URL
                return `${domain}/static/img/hp-social-int-logo.svg`
            },
            showRatingsChart () {
                return (this.oneStar + this.twoStar + this.threeStar + this.fourStar + this.fiveStar) > 0
            },
            hasBusinessDescription () {
                return typeof this.record !== 'undefined' &&
                    typeof this.record.businessDetails !== 'undefined' &&
                    typeof this.record.businessDetails.description === 'string' &&
                    this.record.businessDetails.description.length > 0
            },
            hasBusinessAddress () {
                return typeof this.record !== 'undefined' &&
                    typeof this.record.businessDetails !== 'undefined' &&
                    typeof this.record.businessDetails.address === 'string' &&
                    this.record.businessDetails.address.length > 6
            },
            hasBusinessEmail () {
                return typeof this.record !== 'undefined' &&
                    typeof this.record.businessDetails !== 'undefined' &&
                    typeof this.record.businessDetails.email === 'string' &&
                    this.record.businessDetails.email.length > 0
            },
            hasBusinessPhone () {
                return typeof this.record !== 'undefined' &&
                    typeof this.record.businessDetails !== 'undefined' &&
                    typeof this.record.businessDetails.tel === 'string' &&
                    this.record.businessDetails.tel.length > 0
            },
            hasWebsite () {
                return typeof this.record !== 'undefined' &&
                    typeof this.record.businessDetails !== 'undefined' &&
                    typeof this.record.businessDetails.website === 'string' &&
                    this.record.businessDetails.website.length > 0
            },
            connectWithText () {
                if (typeof this.record !== 'undefined') {
                    return `Connect with ${this.record.businessName}:`
                }
                return ''
            },
            aboutText () {
                if (typeof this.record !== 'undefined') {
                    return `About ${this.record.businessName}:`
                }
                return ''
            },
            hasSocialLinks () {
                return typeof this.socialLinks !== 'undefined' && this.socialLinks.length > 0
            },
            hasKeywords () {
                return typeof this.keywords !== 'undefined' && this.keywords.length > 0
            },
            isReviewDetailsPage () {
                return typeof this.$route.params.permalink !== 'undefined'
            },
            showAdThree () {
                return true
            },
            showAdFour () {
                return true
            },
            getNpsTotal () {
                if (typeof this.record !== 'undefined' && typeof this.record.nps !== 'undefined') {
                    return this.record.nps.nps_total
                }
                return 0
            },
            hasNpsData () {
                return typeof this.record !== 'undefined' &&
                    typeof this.record.nps !== 'undefined' &&
                    (this.record.nps.detractors > 0 ||
                        this.record.nps.passives > 0 ||
                        this.record.nps.promoters > 0 ||
                        this.record.nps.totalRespondents > 0)
            },
            reviewDetailSnippet () {
                if (this.reviewDetailAuthor.length > 0 && this.reviewDetailDate.length > 0) {
                    const dateFilter = moment(this.reviewDetailDate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY, HH:mm')
                    return `<span class="has-text-weight-bold">Written by:</span>&nbsp;${this.reviewDetailAuthor}&nbsp;|&nbsp;${dateFilter}`
                }
                return ''
            },
            websiteFullPath () {
                if (typeof this.record !== 'undefined' && typeof this.record.businessDetails !== 'undefined' && typeof this.record.businessDetails.website !== 'undefined' && this.record.businessDetails.website !== null && this.record.businessDetails.website.length > 0) {
                    const url = this.record.businessDetails.website
                    if (url.startsWith('http')) {
                        return this.record.businessDetails.website
                    }
                    return `http://${this.record.businessDetails.website}`
                }
                return ''
            },
            portalFeaturesUrl () {
                const portalUrl = process.env.PORTAL_URL
                return `${portalUrl}/features`
            },
            hasStatsAndDetailAndGraph () {
                const hasStats = parseInt(this.hasStats)
                const hasGraph = parseInt(this.hasGraph)
                const hasDetail = parseInt(this.hasDetail)
                return `${hasStats},${hasGraph},${hasDetail}`
            },
            hasPaidSubscription () {
                return typeof this.record !== 'undefined' && this.record.businessDetails.isPaid
            },
            /***
             * Convert response time to hour
             * @return {void}
             */
            printAverageResponseTime () {
              if (this.averageResponseTime > 0) {
                return `&nbsp;&nbsp;HOURS`
              }
              return ``
            },
        },
        methods: {
            async getBusinessDetail () {
                this.fetchingBusiness = true
                axios.get(`/consumer/business/${this.business}`)
                    .then(({data}) => {
                        this.record = data
                        this.hasDetail = true
                        if (typeof data.businessDetails !== 'undefined') {
                            this.keywords = data.businessDetails.keywords
                            window.events.$emit('loaded-business-keywords', {
                                keywords: this.keywords
                            })
                        }
                        this.fetchingBusiness = false
                        this.addSocialLinks()
                    })
                    .catch((error) => {
                        this.fetchingBusiness = false
                    })
            },
            async getBusinessStats () {
                this.fetchingStats = true
                axios.get(`/consumer/business-stats/${this.business}`)
                    .then(({data}) => {
                        this.hasStats = true
                        this.stats = data
                        this.totalReviews = parseInt(data.totalReviews)
                        this.averageRating = parseFloat(data.reviewAverage)
                        this.averageResponseTime = data.avgResponseTime
                        if (typeof data.monthlyStats !== 'undefined' && typeof data.monthlyStats.months !== 'undefined') {
                            this.monthRecords = data.monthlyStats.months
                        }
                        if (typeof data.reviewRatings !== 'undefined' && typeof data.reviewRatings.rows !== 'undefined') {
                            data.reviewRatings.rows.forEach((row) => {
                                switch (row[0]) {
                                    case '1 Star':
                                        this.oneStar = row[1]
                                        break
                                    case '2 Stars':
                                        this.twoStar = row[1]
                                        break
                                    case '3 Stars':
                                        this.threeStar = row[1]
                                        break
                                    case '4 Stars':
                                        this.fourStar = row[1]
                                        break
                                    case '5 Stars':
                                        this.fiveStar = row[1]
                                        break
                                    default:
                                        break
                                }
                            })
                        }
                        window.events.$emit('loaded-business-stats', {
                            stats: this.stats,
                            totalReviews: this.totalReviews,
                            averageRating: this.averageRating,
                            monthRecords: this.monthRecords,
                            oneStar: this.oneStar,
                            twoStar: this.twoStar,
                            threeStar: this.threeStar,
                            fourStar: this.fourStar,
                            fiveStar: this.fiveStar,
                            pagination: this.pagination
                        })
                        this.fetchingStats = false
                    })
                    .catch((error) => {
                        console.log('error', error)
                        this.fetchingStats = false
                    })
            },
            async getMonthOnMonthGraph () {
                let endDate = moment()
                let startDate = moment()
                endDate.subtract(1, 'month')
                endDate.endOf('month')
                startDate.subtract(4, 'months')
                startDate.startOf('month')
                endDate = moment(endDate).format('YYYY-MM-DD')
                startDate = moment(startDate).format('YYYY-MM-DD')

                const dateQuery = qs.stringify({
                    start_date: startDate,
                    end_date: endDate
                })
                axios.get(`/${this.business}/reports/trust-index-over-time?${dateQuery}`)
                    .then(({data}) => {
                        this.hasGraph = true
                        this.trustIndexOverTimeRows = data.rows
                        this.trustIndexOverTimeColumns = data.columns
                        this.trustIndexOverTimeOptions.chartArea.bottom = '15%'
                        this.trustIndexOverTimeOptions.height = '250'
                        window.events.$emit('loaded-business-month-on-month-graph', {
                            trustIndexOverTimeRows: this.trustIndexOverTimeRows,
                            trustIndexOverTimeColumns: this.trustIndexOverTimeColumns,
                            trustIndexOverTimeOptions: this.trustIndexOverTimeOptions
                        })
                    })
                    .catch((error) => {
                        console.log('error', error)
                    })
            },
            addSocialLinks () {
                if (typeof this.record !== 'undefined') {
                    // facebook
                    if (typeof this.record.businessDetails.facebook !== 'object' && typeof this.record.businessDetails.facebook !== 'undefined' && this.record.businessDetails.facebook.length > 0) {
                        let url = this.record.businessDetails.facebook
                        if (!url.startsWith('http')) {
                            url = `https://${url}`
                        }
                        this.socialLinks.push({
                            style: 'social-facebook',
                            icon: 'fab fa-facebook-f',
                            url: url
                        })
                        this.socialLinksOffset.pop()
                    }
                    // twitter
                    if (typeof this.record.businessDetails.twitter !== 'object' && typeof this.record.businessDetails.twitter !== 'undefined' && this.record.businessDetails.twitter.length > 0) {
                        let url = this.record.businessDetails.twitter
                        if (!url.startsWith('http')) {
                            url = `https://${url}`
                        }
                        this.socialLinks.push({
                            style: 'social-twitter',
                            icon: 'fab fa-twitter',
                            url: url
                        })
                        this.socialLinksOffset.pop()
                    }
                    // linkedin
                    if (typeof this.record.businessDetails.linkedin !== 'object' && typeof this.record.businessDetails.linkedin !== 'undefined' && this.record.businessDetails.linkedin.length > 0) {
                        let url = this.record.businessDetails.linkedin
                        if (!url.startsWith('http')) {
                            url = `https://${url}`
                        }
                        this.socialLinks.push({
                            style: 'social-linkedin',
                            icon: 'fab fa-linkedin-in',
                            url: url
                        })
                        this.socialLinksOffset.pop()
                    }
                    // google
                    if (typeof this.record.businessDetails.google !== 'object' && typeof this.record.businessDetails.google !== 'undefined' && this.record.businessDetails.google.length > 0) {
                        let url = this.record.businessDetails.google
                        if (!url.startsWith('http')) {
                            url = `https://${url}`
                        }
                        this.socialLinks.push({
                            style: 'social-google',
                            icon: 'fab fa-google',
                            url: url
                        })
                        this.socialLinksOffset.pop()
                    }
                    // instagram
                    if (typeof this.record.businessDetails.instagram !== 'object' && typeof this.record.businessDetails.instagram !== 'undefined' && this.record.businessDetails.instagram.length > 0) {
                        let url = this.record.businessDetails.instagram
                        if (!url.startsWith('http')) {
                            url = `https://${url}`
                        }
                        this.socialLinks.push({
                            style: 'social-instagram',
                            icon: 'fab fa-instagram',
                            url: url
                        })
                        this.socialLinksOffset.pop()
                    }

                    window.events.$emit('loaded-business-details', {
                        record: this.record,
                        socialLinks: this.socialLinks,
                        socialLinksOffset: this.socialLinksOffset,
                        bizCategories: this.record.businessCategories
                    })
                }
            }
        },
        data () {
            return {
                isMobileAds: false,
                desktopAds: [],
                hasStats: false,
                hasDetail: false,
                hasGraph: false,
                reviewDetailAuthor: '',
                reviewDetailDate: '',
                averageResponseTime: 0,
                fetchingBusiness: false,
                smallTopMargin: true,
                fetchingStats: false,
                record: undefined,
                stats: undefined,
                smallStars: true,
                pagination: {
                    last_page: 0,
                    current_page: 0
                },
                monthRecords: [],
                starDescriptionText: true,
                oneStar: 0,
                twoStar: 0,
                threeStar: 0,
                fourStar: 0,
                fiveStar: 0,
                totalReviews: 0,
                averageRating: 0,
                socialLinks: [],
                socialLinksOffset: [{}, {}, {}, {}, {}],
                keywords: [],
                trustIndexOverTimeColumns: [],
                trustIndexOverTimeRows: [],
                trustIndexOverTimeOptions: {
                    title: '',
                    legend: 'none',
                    vAxis: {
                        title: '',
                        textStyle: {
                            color: '#7b7c7e',
                            bold: true
                        },
                        viewWindow: { max: 10 },
                        viewWindowMode: 'explicit'
                    },
                    hAxis: {
                        title: '',
                        textStyle: {
                            color: '#7b7c7e'
                        }
                    },
                    height: 100,
                    pointSize: 10,
                    series: {
                        0: {
                            type: 'line',
                            color: '#30AAE1'
                        }
                    },
                    chartArea: {
                        'width': '100%',
                        'height': '50%',
                        top: '15%',
                        bottom: '50%',
                        left: '15%',
                        right: '10%'
                    }
                },
                showTooltip: false
            }
        },
        watch: {
            hasStatsAndDetailAndGraph () {
                window.prerenderReady = true
            }
        },
        filters: {
            precise (value, length = 2) {
                if (!value) {
                    return ''
                }
                return value.toFixed(length)
            },

            /**
             * Break sentence if longer than given length
             * @param {String} sent Sentence to break
             * @param {Number} charsInLine Number of character to show in a single line
             * @returns {String} Formated sentence
             */
            breakSent (sent, charsInLine = 40) {
                sent = sent.trim();
                if (window.innerWidth < 1025 || !sent || sent.length <= charsInLine) { // Sentence is less than 40 characters
                    return sent;
                }

                if (!sent.charAt(charsInLine-1) || !sent.charAt(charsInLine)) { // At 39th index, a word is completing. So we can break the sentence.
                    return `${sent.substr(0, charsInLine)} <br /> ${this.breakSent(sent.substr(charsInLine))}`;
                }

                // Word is not completing at 39th index. Find index of start of the current word
                const wordStart = sent.lastIndexOf(" ", charsInLine-1) + 1;
                if (!wordStart) { // Word is first word in sentence
                    const nextWord = sent.indexOf(" ", charsInLine-1) + 1; // Finding next word index
                    if (nextWord > 0) { // We have next word in sentence. Extract upto next word and print them
                        return `${sent.substring(0, nextWord)} <br /> ${this.breakSent(sent.substr(nextWord))}`;
                    }
                    else { // No next word found. Print whole sentence.
                        return sent;
                    }
                }
                else { // There are words before the word. Extract and print them
                    return `${sent.substring(0, wordStart)} <br /> ${this.breakSent(sent.substr(wordStart))}`;
                }
            }
        }
    }
</script>
<style scoped>
    .business-logo {
        width: 140px;
        margin-right: 20px;
        border-radius: 50%;
        border: 1px solid #F5F5F5;
    }

    .business-logo.is-review-detail {
        width: 80px;
    }

    .section.business-summary {
        width: 100%;
        max-width: 1125px;
        padding: 3rem 0;
        margin: 0 auto;
    }

    .section.business-summary.is-review-summary {
        padding: 1.5rem 0;
    }

    .business-name, .industry > a, .industry > a:hover, .industry > a:visited, .review-summary, .review-summary {
        color: #58595B!important;
    }

    .industry > a {
        text-decoration: none;
    }

    .business-name {
        font-size: 1.1rem;
    }

    .industry {
        font-size: 1rem;
    }

    .review-summary {
        font-size: 0.85rem;
    }

    .responding-business {
        width: 42px;
        position: relative;
        margin-left: -34px;
        margin-bottom: -100px;
        margin-right: 21px;
    }

    .container-box {
        display: block;
        width: 174px;
        box-shadow: 0px 0px 23px -1px rgba(166,159,166,0.32);
        padding: 0.7rem;
    }

    .container-box > p {
        width: 100%;
        display: block;
        padding: 0;
        text-align: center;
    }

    .container-box > p:nth-child(odd) {
        font-size: 0.75rem;
    }

    .container-box > p:nth-child(even) {
        font-size: 2.5rem;
    }

    .nps-total {
        display: block;
        width: 68px;
        height: 68px;
        border: 5px solid #2FABE1;
        border-radius: 50%;
        font-size: 1.4rem;
        text-align: center;
        line-height: 60px;
        margin: 6px auto;
    }

    .level-right > .level-item:not(:last-child) {
        margin-right: 1.5rem;
    }

    .section.business-columns {
        border-top: 1px solid #C9C9C9;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-repeat: no-repeat;
        background-image: linear-gradient(to right, #ffffff 65%, #F5F5F5 20%);
    }

    .right-column > .container {
        width: 75%;
        margin-left: 28%;
        color: #58595B;
    }

    .industry-rank-card {
        background-color: #ffffff;
    }

    .industry-rank-card, .vue-chart-container {
        box-shadow: 0px 0px 23px -1px rgba(166,159,166,0.32);
    }

    .right-column > .container > h4 {
        font-size: 0.9rem;
        margin-bottom: 0.5rem;
        margin-top: 2rem;
    }

    .right-column > .container > h4:first-child {
        margin-top: 1rem;
    }

    .columns > .industry-rank-card {
        margin-right: 10px;
        text-align: center;
    }

    .columns > .industry-rank-card > span:first-child {
        font-weight: bold;
    }

    .columns > .industry-rank-card:last-child {
        margin-right: 0;
    }

    .business-description {
        font-size: 0.85rem;
        margin-bottom: 25px;
    }

    .button.is-outlined {
        background-color: transparent;
        color: #30AAE1;
        border: 1px solid #30AAE1;
        border-radius: 0;
        font-size: 0.85rem;
        padding: 1.3rem 2rem;
    }

    .social-facebook, .social-twitter, .social-linkedin, .social-google, .social-instagram {
        color: #ffffff;
        display: block;
        width: 33px;
        height: 33px;
        border-radius: 50%;
        font-size: 1.3rem;
        line-height: 33px;
        text-align: center;
        margin-left: auto;
        margin-right: auto;
    }

    .social-facebook {
        background-color: #3B5998;
    }
    .social-twitter {
        background-color: #00ACED;
    }
    .social-linkedin {
        background-color: #0E76A8;
    }
    .social-google {
        background-color: #D34836;
    }
    .social-instagram {
        background-color: #FB3958;
    }

    .mini-title, .mini-detail {
        color: #707070;
        font-size: 0.85rem;
    }

    .mini-title {
        font-weight: bold;
    }

    .mini-detail {
        margin-top:5px;
        margin-bottom: 15px;
    }

    .left-pane {
        margin: 0 35px 35px auto;
        width: 100%;
        max-width: 750px;
    }

    .tag.is-white {
        margin-right: 10px;
        margin-bottom: 10px;
        color: #707070;
        border-radius: 0;
    }

    .business-name > a, .business-name > a:hover, .business-name > a:visited {
        text-decoration: none;
        color: #58595B;
    }

    .review-author-details {
        font-size: 0.9rem;
        color: #8A8C91;
    }

    .business-name.review-details {
        font-size: 1.2rem;
    }

    .left-pane iframe {
        width: 100%!important;
    }

    .no-nps-data {
        width: 68px;
        height: 68px;
        color: #707070;
        font-size: 0.8rem!important;
        text-align: center;
        line-height: 23px;
        margin: 5px auto;
        display: flex !important;
        align-items: center;
    }

    .line-heigth-23 {
        line-height: 23px!important;
    }

    .zero-trust-index {
        line-height: 1rem!important;
        top: 1px!important;
        font-weight: normal!important;
    }

    .is-this-your-business > a, .is-this-your-business > a:visited, .is-this-your-business > a:hover {
        font-size: 0.9rem;
        color: #2EAAE1;
        text-decoration: underline;
    }

    .is-this-your-business.is-hidden-mobile {
        margin-top: -18px;
        margin-bottom: -18px;
    }

    .flash-desktop {
      width: 100%;
      margin-bottom: 20px;
    }

    .flash-mobile {
      float: left;
      width: 100%;
      margin: 5px 0;
    }

    .flash-mobile > div {
      width: 90%;
      margin: 0 auto;
    }

    @media screen and (max-width: 1024px) {
        .business-logo {
            width: 111px;
        }

        .section.business-summary {
            padding: 1.3rem!important;
        }

        .responding-business {
            width: 34px;
            position: relative;
            margin-left: -50px;
            margin-bottom: -80px;
            margin-right: 5px;
        }

        .business-name {
            font-size: 1rem;
        }

        .industry {
            font-size: 0.8rem;
        }

        .review-summary {
            font-size: 0.75rem;
        }

        .summary {
            max-width: 150px;
            line-height: 1.2rem;
        }

        .container-box {
            width: 114px;
            height: 136px;
        }

        .section.business-summary.is-review-summary .summary {
            max-width: 800px;
        }
    }

    @media screen and (max-width: 767px) {

        .verified-biz {
          width: 42px;
          margin-left: -22px;
          margin-bottom: -15px;
        }

        .section.business-summary {
            padding: 1.3rem;
        }

        .section.business-summary.is-review-summary {
            display: none;
        }

        .business-logo {
            width: 75px;
            position: relative;
            top: -20px;
        }

        .responding-business {
            width: 23px;
            position: relative;
            margin-left: -40px;
            margin-bottom: -12px;
            margin-right: 5px;
        }

        .summary-trust-index {
            font-size: 0.9rem;
            line-height: 2rem;
            position: relative;
            top: -23px;
        }

        .summary {
            width: 100%;
        }

        .review-count {
            font-size: 0.75rem;
            position: relative;
            left: 130px;
            top: -20px;
        }

        .section.business-columns {
            border: none;
        }

        .left-pane.is-review-details {
            margin: 0;
        }
        .level-item.mobile-level {
            padding-bottom: 12px;
        }

      .section.business-columns{
        background-image: none;
      }
      .review-details-list{
        width:100%;
      }
    }
    .nps-component-icon {
        cursor: pointer;
        position: absolute;
        bottom: 9px;
    }
    .fa-check-circle {
        color: #4db888;
        margin-right: 6px;
        height: 25px;
    }
    .fa-check-circle-mobile {
        color: #4db888;
        margin-right: 6px;
        height: 20px;
    }
    .verify-text {
      display: flex;
      position: relative;
      color: #4ba9e0 !important;
      margin-top: 8px;
    }
    .verify-text-mobile {
        display: flex;
        position: relative;
        color: #4ba9e0 !important;
        margin-top: -20px;
    }
    .verified-biz-desktop {
      width: 42px;
      margin-left: -27px;
      margin-bottom: -100px;
    }
    .avg-rating {
      margin-bottom: -3px !important
    }
    .verify-text > span {
        margin-top: 2px;
    }
    .net-promoter {
        position: relative;
    }
    .nps-data {
        padding-bottom: 16px !important;
    }
    .v-popover{
      height: 0px !important;
    }
    .grey-back {
      position: relative;
      background-color: rgba(255,255,255,0.5);
      color: #58595B;
      padding: 0.75rem 1.5rem 0.75rem 1rem;
      margin-top:10px;
      webkit-box-shadow: 0px 0px 23px -1px rgba(166,159,166,0.32);
      box-shadow: 0px 0px 23px -1px rgba(166,159,166,0.32);
    }

    .grey-back .media-content{min-width:65%;}
    .media-content > .is-height-45 {
      line-height: 22px;
    }
    .grey-back .media-right p {
      line-height: 22px;
      font-size:22px !important;

    }

    .media-content > p{font-size:12px;line-height:16px !important;}

    .grey-back .image{
      width: 45px;
      height: 45px;
    }

  .grey-back .time_content{position: absolute;text-align: center;top:35px;right:0;left:0;}
    .grey-back .time_content .media-right{
      margin: 0;
      width: 60%;
      text-align: right}
    .grey-back .time_content p{font-size:17px !important;line-height: 16px; }
    .grey-back .time_content .level-item p{font-size:12px !important;position: absolute;top: 1px;right: 58px;}

    .section.business-columns {background-image: linear-gradient(to right, #ffffff 63%, #F5F5F5 20%);}

  .review-details-list {
    max-width: 1125px;
  }
  .review-details-list-inner {
    padding-left: 0px;
  }
  @media screen and (max-width: 1023px) and (min-width: 768px) {
    .section.business-columns {background:none;}
  }
  @media screen and (max-width: 767px) {
   .section.business-columns {background:none;}
    .rev-title strong a[data-v-2a945139] {
      word-wrap: break-word;
    }
  }
  @media screen and (max-width: 1366px) and (min-width: 1024px) {
   .section.business-columns {background-image: linear-gradient(to right, #ffffff 69%, #F5F5F5 20%);}
  }

  @media(max-width: 1199px){
    .is-size-ipad {
      font-size: 13px !important;
    }
    .time_content .media-right p {
      font-size: 12px !important;
    }
    .grey-back .time_content .level-item p {
      font-size: 10px !important;
    }
  }
  .width-95 {
    width: 95%;
    margin: 0 auto;
  }

</style>



// WEBPACK FOOTER //
// src/pages/business/BusinessDetail.vue